import { Component, inject, input, output, TemplateRef } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AccessGroup, AccessGroupSearchEvent } from 'src/app/features/access-groups/access-group.model';
import { AccessGroupService } from '../../services/access-group.service';
import { PagedResult } from '../../models/paging';
import { TypeAheadSelector2Component } from '../type-ahead-selector2/type-ahead-selector2.component';

@Component({
  selector: 'adm-access-group-typeahead',
  imports: [TypeAheadSelector2Component],
  templateUrl: './ag-typeahead.component.html',
  styleUrl: './ag-typeahead.component.scss',
})
export class AdmAccessGroupTypeaheadComponent {
  accessGroupService = inject(AccessGroupService);
  organizationId = input<number | null>(null);
  accessGroupId = input<string | null>(null);
  itemSelected = output<AccessGroup | null>();
  resetTrigger = input<{ reset: boolean }>({ reset: false });
  itemTemplate = input<TemplateRef<any>>();

  fetchAccessGroups = (term: string): Observable<AccessGroup[]> => {
    const searchEvent = <AccessGroupSearchEvent>{
      paging: { pageIndex: 0, pageSize: 20, length: 0 },
      sorting: null,
      query: term.length > 0 ? term : null,
      organizationId: this.organizationId(),
    };
    return this.accessGroupService.getAccessGroups(searchEvent).pipe(map((result: PagedResult<AccessGroup>) => result.items));
  };

  fetchAccessGroupById = (identifier: string): Observable<AccessGroup | null> => {
    return this.accessGroupService
      .getAccessGroups({ accessGroupIdentifier: identifier, paging: { pageSize: 1, pageIndex: 0 } } as AccessGroupSearchEvent)
      .pipe(map((result: PagedResult<AccessGroup>) => result.items[0] ?? null));
  };

  accessGroupSelected = (ag: AccessGroup | null | undefined) => {
    this.itemSelected.emit(ag ?? null);
  };
}
